{
  "REPORT": {
    "HEADER": "Samtaler",
    "LOADING_CHART": "Laster inn diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke mottatt nok data for å generere rapporten, vennligst prøv igjen senere.",
    "DOWNLOAD_AGENT_REPORTS": "Last ned agentrapporter",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "(Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Innkommende meldinger",
        "DESC": "(Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meldinger",
        "DESC": "(Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsningstid",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antall løsninger",
        "DESC": "(Totalt )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Antall løsninger",
        "DESC": "(Totalt )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "(Totalt )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "TODAY": "I dag",
      "YESTERDAY": "I går",
      "LAST_7_DAYS": "Siste 7 dager",
      "LAST_30_DAYS": "Siste 30 dager",
      "THIS_MONTH": "Denne måneden",
      "LAST_MONTH": "Forrige måned",
      "LAST_3_MONTHS": "Last 3 months",
      "LAST_6_MONTHS": "Last 6 months",
      "LAST_YEAR": "Last year",
      "CUSTOM_DATE_RANGE": "Custom date range"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Group By",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "Day",
      "WEEK": "Week",
      "MONTH": "Month",
      "YEAR": "Month"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Day"
      },
      {
        "id": 2,
        "groupBy": "Week"
      },
      {
        "id": 3,
        "groupBy": "Month"
      }
    ],
    "BUSINESS_HOURS": "Business Hours",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ingen resultater funnet"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Samtaler: {count}",
      "RESULT_COUNT_MESSAGE": "Meldinger: {count}",
      "EMPTY": "Fant ingen poster for denne søylen.",
      "ERROR": "Kunne ikke laste postene. Prøv igjen.",
      "LOAD_MORE": "Last inn flere",
      "PREVIOUS_BUCKET": "Forrige søyle",
      "NEXT_BUCKET": "Neste søyle",
      "UNKNOWN_CONTACT": "Ukjent kontakt",
      "UNKNOWN_INBOX": "Ukjent innboks",
      "UNASSIGNED_AGENT": "Ikke tildelt",
      "NO_MESSAGE_CONTENT": "Ingen meldingsinnhold",
      "MESSAGE_CREATED_AT": "Melding opprettet {time}",
      "EVENT_OCCURRED_AT": "Hendelse skjedde {time}",
      "INCOMING_MESSAGE": "Innkommende melding",
      "OUTGOING_MESSAGE": "Utgående melding",
      "VIEW_ALL": "Vis i samtaler",
      "VIEW_ALL_LIMIT": "Bare søyler med høyst {limit} samtaler kan åpnes i samtalelisten.",
      "HIDDEN_COUNT": "Ikke vist fordi du ikke er medlem av innboksen deres: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agents Overview",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Laster inn diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke mottatt nok data for å generere rapporten, vennligst prøv igjen senere.",
    "DOWNLOAD_AGENT_REPORTS": "Last ned agentrapporter",
    "FILTER_DROPDOWN_LABEL": "Velg agent",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "(Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Innkommende meldinger",
        "DESC": "(Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meldinger",
        "DESC": "(Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsningstid",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antall løsninger",
        "DESC": "(Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Siste 7 dager"
      },
      {
        "id": 1,
        "name": "Siste 30 dager"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Labels Overview",
    "DESCRIPTION": "Følg ytelsen til etikettene med nøkkeltall som samtaler, svartider, løsningstider og løste saker.",
    "LOADING_CHART": "Laster inn diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke mottatt nok data for å generere rapporten, vennligst prøv igjen senere.",
    "DOWNLOAD_LABEL_REPORTS": "Download label reports",
    "FILTER_DROPDOWN_LABEL": "Select Label",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "(Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Innkommende meldinger",
        "DESC": "(Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meldinger",
        "DESC": "(Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsningstid",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antall løsninger",
        "DESC": "(Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Siste 7 dager"
      },
      {
        "id": 1,
        "name": "Siste 30 dager"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Inbox Overview",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Laster inn diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke mottatt nok data for å generere rapporten, vennligst prøv igjen senere.",
    "DOWNLOAD_INBOX_REPORTS": "Download inbox reports",
    "FILTER_DROPDOWN_LABEL": "Select Inbox",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "(Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Innkommende meldinger",
        "DESC": "(Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meldinger",
        "DESC": "(Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsningstid",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antall løsninger",
        "DESC": "(Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Siste 7 dager"
      },
      {
        "id": 1,
        "name": "Siste 30 dager"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team Overview",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Laster inn diagramdata...",
    "NO_ENOUGH_DATA": "Vi har ikke mottatt nok data for å generere rapporten, vennligst prøv igjen senere.",
    "DOWNLOAD_TEAM_REPORTS": "Download team reports",
    "FILTER_DROPDOWN_LABEL": "Select Team",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Samtaler",
        "DESC": "(Totalt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Innkommende meldinger",
        "DESC": "(Totalt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Utgående meldinger",
        "DESC": "(Totalt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "First Response Time",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "First Response Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Løsningstid",
        "DESC": "( Gj. sn. )",
        "INFO_TEXT": "Total number of conversations used for computation:",
        "TOOLTIP_TEXT": "Resolution Time is {metricValue} (based on {conversationCount} conversations)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Antall løsninger",
        "DESC": "(Totalt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Siste 7 dager"
      },
      {
        "id": 1,
        "name": "Siste 30 dager"
      },
      {
        "id": 2,
        "name": "Last 3 months"
      },
      {
        "id": 3,
        "name": "Last 6 months"
      },
      {
        "id": 4,
        "name": "Last year"
      },
      {
        "id": 5,
        "name": "Custom date range"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Apply",
      "PLACEHOLDER": "Select date range"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT Reports",
    "NO_RECORDS": "There are no CSAT survey responses available.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Choose Agents"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Contact",
        "AGENT_NAME": "Assigned agent",
        "RATING": "Rating",
        "FEEDBACK_TEXT": "Feedback comment"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Total responses",
        "TOOLTIP": "Total number of responses collected"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Satisfaction score",
        "TOOLTIP": "Total number of positive responses / Total number of responses * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Response rate",
        "TOOLTIP": "Total number of responses / Total number of CSAT survey messages sent * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "CONVERSATION_COUNT": {
        "LABEL": "Antall samtaler",
        "TOOLTIP": "Totalt antall samtaler med botmeldinger"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Antall svar",
        "TOOLTIP": "Totalt antall utgående meldinger"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Antall AI-svar",
        "TOOLTIP": "Totalt antall svarmeldinger sendt av boten"
      },
      "COPILOT_COUNT": {
        "LABEL": "Antall forberedte svar",
        "TOOLTIP": "Totalt antall copilot-forslag forberedt av boten for agenter"
      },
      "SUCCESS_RATE": {
        "LABEL": "Løst av AI",
        "TOOLTIP": "Prosentandel samtaler løst av AI uten overføring til agent"
      },
      "RESOLVE_TIME": {
        "LABEL": "Løsningstid",
        "TOOLTIP": "Median tid fra første kundemelding til siste bot-/agentmelding"
      },
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    },
    "GROUP_BY": {
      "NONE": "Ikke grupper",
      "INBOXES": "Innbokser",
      "LABELS": "Etiketter"
    },
    "GROUPED": {
      "CHART_TITLE": "Fordeling per gruppe",
      "BACK_TO_ALL": "Vis alle",
      "TABLE": {
        "INBOX": "Innboks",
        "LABEL": "Etikett",
        "CONVERSATIONS": "Samtaler",
        "MESSAGES": "Meldinger",
        "MESSAGES_TOOLTIP": "Totalt antall utgående meldinger",
        "AI_MESSAGES": "AI-svar",
        "AI_MESSAGES_TOOLTIP": "Totalt antall AI-svar, etterfulgt av antall positive og negative vurderinger fra sluttbrukere",
        "THUMBS_UP_TOOLTIP": "Antall AI-svar vurdert som positive (tommel opp) av sluttbrukere",
        "THUMBS_DOWN_TOOLTIP": "Antall AI-svar vurdert som negative (tommel ned) av sluttbrukere",
        "PREPARED": "Forberedte svar",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Prosentandel meldinger av alle meldinger som tilhører denne gruppen",
        "BOT_RESPONSES": "AI-svar %",
        "SUGGESTION_USED": "Brukte svar",
        "SUGGESTION_USED_TOOLTIP": "Prosentandel forberedte svar i denne gruppen som ble brukt av agenter",
        "SUGGESTION_NOT_USED": "Ubrukte svar",
        "SUGGESTION_NOT_USED_TOOLTIP": "Prosentandel meldinger i denne gruppen som hadde et forberedt svar, men som ikke ble brukt"
      },
      "NOTES": {
        "TITLE": "Hvordan statistikken beregnes",
        "CONVERSATIONS": "Antall samtaler med minst én utgående melding i den valgte perioden.",
        "MESSAGES": "Totalt antall utgående (ikke-private) meldinger sendt i den valgte perioden. Dette inkluderer både AI-genererte og menneskeskrevne meldinger.",
        "PERCENTAGE": "Andelen av denne gruppens meldinger av alle utgående meldinger på tvers av alle grupper.",
        "AI_MESSAGES": "Antall utgående meldinger sendt automatisk av AI-boten (uten forberedte svar for agenter). Tallene i parentes viser hvor mange av disse svarene som ble vurdert som positive (tommel opp) og negative (tommel ned) av sluttbrukere.",
        "PREPARED": "Antall copilot-forslag (forberedte svar) generert av AI-boten for agenter i den valgte perioden. Dette er private meldinger som bare er synlige for agenter, og de telles ikke som utgående meldinger, så dette tallet samsvarer kanskje ikke med kolonnen Meldinger.",
        "SUGGESTION_USED": "Prosentandel forberedte svar i denne gruppen som ble brukt av agenter. Dette samsvarer kanskje ikke med antallet forberedte svar, siden det også kan inkludere forslag generert i tidligere perioder.",
        "SUGGESTION_NOT_USED": "Prosentandel utgående meldinger i denne gruppen der et copilot-forslag var tilgjengelig, men agenten svarte uten å bruke det. Telles bare når agenten faktisk sendte et svar. Dette samsvarer kanskje ikke med antallet forberedte svar, siden det også kan inkludere forslag generert i tidligere perioder."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Overview",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Open Conversations",
      "LOADING_MESSAGE": "Loading conversation metrics...",
      "OPEN": "Åpne",
      "UNATTENDED": "Unattended",
      "UNASSIGNED": "Ikke tildelt",
      "PENDING": "Ventende"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Conversations by agents",
      "LOADING_MESSAGE": "Loading agent metrics...",
      "NO_AGENTS": "There are no conversations by agents",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Åpne",
        "UNATTENDED": "Unattended",
        "STATUS": "Satus"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Gruppe",
        "OPEN": "Åpne",
        "UNATTENDED": "Udeltatt",
        "STATUS": "Satus"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agent status",
      "ONLINE": "Pålogget",
      "BUSY": "Opptatt",
      "OFFLINE": "Frakoblet"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "Ingen resultater funnet",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent navn",
        "INBOXES": "Navn på innboks",
        "LABELS": "Etikettens navn",
        "TEAMS": "Team name"
      },
      "SLA": "SLA Policy",
      "INBOXES": "Inbox",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "Conversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Delsum",
    "NO_TEAM": "Inget team",
    "GROUP_BY_TEAMS": "Grupper etter team",
    "INBOX": "Innboks",
    "AGENT": "Agent",
    "TEAM": "Gruppe",
    "LABEL": "Etikett",
    "TOTAL": "Totalt",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Antall løsninger",
    "CONVERSATIONS": "Antall samtaler",
    "OUTGOING_CHATS": "Utgående chatter",
    "OUTGOING_EMAILS": "Utgående e-poster",
    "PHONE_CALLS": "Telefonsamtaler",
    "INBOUND_CALLS": "Innkommende anrop",
    "OUTBOUND_CALLS": "Utgående anrop",
    "TOTAL_ACTIVITIES": "Totalt antall aktiviteter",
    "ONLINE_TIME": "Pålogget tid",
    "QUEUE_AVAILABLE_TIME": "Tilgjengelig tid i kø",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Antall utgående meldinger sendt av denne agenten",
      "OUTGOING_EMAILS": "Antall utgående e-poster sendt av denne agenten",
      "PHONE_CALLS": "Totalt antall telefonsamtaler tildelt denne agenten (sum av innkommende og utgående anrop)",
      "TOTAL_ACTIVITIES": "Totalt antall aktiviteter: innkommende anrop + utgående anrop + utgående chatter + utgående e-poster",
      "INBOUND_CALLS": "Antall innkommende telefonsamtaler tildelt denne agenten",
      "OUTBOUND_CALLS": "Antall utgående telefonsamtaler tildelt denne agenten",
      "AVG_FIRST_RESPONSE_TIME": "Gjennomsnittlig tid fra samtalen ble opprettet til agentens første svar, for samtaler tildelt denne agenten",
      "AVG_RESOLUTION_TIME": "Gjennomsnittlig tid fra samtalen ble opprettet til den ble løst, for samtaler tildelt denne agenten",
      "AVG_REPLY_TIME": "Gjennomsnittlig tid kunder venter mellom sin melding og agentens svar, for samtaler tildelt denne agenten",
      "ONLINE_TIME": "Total tid agenten var pålogget eller opptatt i den valgte perioden",
      "QUEUE_AVAILABLE_TIME": "Total tid agenten var tilgjengelig i telefonkøer i den valgte perioden"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefonrapporter",
    "DESCRIPTION": "Følg statistikk for telefonsamtaler med detaljert innsikt i innkommende og utgående anrop, gruppert etter agent eller innboks for omfattende analyse.",
    "DOWNLOAD_PHONE_REPORTS": "Last ned telefonrapporter",
    "GROUP_BY": {
      "LABEL": "Grupper etter",
      "AGENT": "Agent",
      "INBOX": "Innboks"
    },
    "TABLE": {
      "TOTAL_CALLS": "Totalt",
      "INBOUND_CALLS": "Innkommende",
      "OUTBOUND_CALLS": "Utgående",
      "FAILED_OUTBOUND_CALLS": "Mislykket utgående",
      "AVG_AGENT_HANDLED_DURATION": "Gj.sn. varighet",
      "TOTAL_AGENT_HANDLED_DURATION": "Total varighet",
      "AVG_RINGING_TIME": "Gj.sn. ringetid",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Suksess %",
      "UNIQUE_CALLERS": "Unike innringere",
      "UNIQUE_CALLED_CONTACTS": "Unikt oppringt",
      "UNANSWERED_MISSED_CALLS": "Tapt uten oppfølging",
      "UNANSWERED_MISSED_PERCENTAGE": "Ubesvart tapt %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Tapt uten oppfølging, utilstrekkelig tilbakeringt",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Tapt uten oppfølging, utilstrekkelig tilbakeringt %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Totalt antall anrop (inkludert ikke-tilkoblede)",
      "INBOUND_CALLS": "Antall tilkoblede anrop",
      "OUTBOUND_CALLS": "Antall utgående anrop (inkludert ikke-tilkoblede)",
      "FAILED_OUTBOUND_CALLS": "Antall utgående anrop som ikke ble tilkoblet",
      "AVG_AGENT_HANDLED_DURATION": "Gjennomsnittlig varighet på anrop behandlet av agenter",
      "TOTAL_AGENT_HANDLED_DURATION": "Total varighet på alle anrop behandlet av agenter",
      "AVG_RINGING_TIME": "Gjennomsnittlig tid anrop ringte før de ble besvart",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Prosentandel utgående anrop som ble tilkoblet",
      "UNIQUE_CALLERS": "Antall unike kontakter som ringte inn",
      "UNIQUE_CALLED_CONTACTS": "Antall unike kontakter som ble oppringt via utgående anrop",
      "UNANSWERED_MISSED_CALLS": "Antall tapte anrop der ingen vellykket tilbakeringing ble gjort (anrop tilkoblet). Kan inkludere anrop som fortsatt kan behandles innenfor arbeidsdagen",
      "UNANSWERED_MISSED_PERCENTAGE": "Prosentandel unike innringere hvis anrop ble tapt uten oppfølging (ubesvarte tapte anrop / unike innringere)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Antall tapte anrop med færre enn 2 tilbakeringingsforsøk. Kan inkludere anrop som fortsatt kan behandles innenfor arbeidsdagen",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Prosentandel unike innringere med færre enn 2 tilbakeringingsforsøk ((tapt uten oppfølging - tilstrekkelig behandlet) / unike innringere)"
    }
  }
}
